import store from './store'
import event_bus from '../../eventBus'
import { DLP } from '../modulesNames'
import { ACT_SEND_CLIPBOARD_EVENT } from '../actionsTypes'

event_bus.$on('text-copy', (payload) => {
    store.dispatch(`${DLP}/${ACT_SEND_CLIPBOARD_EVENT}`, payload)
})